<div class="list-pg-inn-sp">
  <div class="list-pg-upro">
    <a (click)="deleteGroup()"><span
      class="waves-effect waves-light btn-large full-btn list-pg-btn">{{'DELETE GROUP' | translate}}</span></a>
  </div>
</div>
